var styleDataHash = "d3216126";
const injectCss = () => {
  var css = `._97S-M,.k6Yry{height:14px;pointer-events:auto;position:relative;width:100%}[dir] ._97S-M,[dir] .k6Yry{cursor:pointer;margin:0;padding:0}._97S-M:hover .sUqfI,.k6Yry:hover .sUqfI{opacity:1}.k6Yry{pointer-events:none}[dir] .k6Yry{cursor:none}.-CY2k .sUqfI{opacity:1}.sUqfI{height:2px;opacity:0;position:absolute;top:50%;transition:opacity .2s ease;width:100%}[dir] .sUqfI{background-color:var(--ricos-action-color,#116dff);transform:translateY(-50%)}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var gap_spacer_styles_default = {
  "gapSpacerContainer": "_97S-M",
  "gapSpacerViewer": "k6Yry",
  "gapSpacerLine": "sUqfI",
  "gapSpacerFocused": "-CY2k"
};
export {
  gap_spacer_styles_default as default,
  injectCss
};
//# sourceMappingURL=gap-spacer-styles-scss.js.map
